import FileSaver from "file-saver";

export function getImgUrl(img) {
  var pixelRatio = getPixelRatio();
  var images = getImagesContext(pixelRatio);
  return images("./" + img);
}

export function getConfiguration() {
  /* eslint-disable no-undef */
  return config;
}

export function title() {
  var config = getConfiguration();
  return config.title;
}

export function version() {
  var config = getConfiguration();
  return config.version;
}

export function getPixelRatio() {
  return window.devicePixelRatio;
}

export function getImagesContext(pixelRatio) {
  // fallback is to scale 1.0
  var images = require.context(
    "../assets/images",
    false,
    /\.jpg$|\.png$|.gif$/
  );

  if (pixelRatio > 1 && pixelRatio < 2) {
    images = require.context(
      "../assets/images/hdpi150",
      false,
      /\.jpg$|\.png$|.gif$/
    );
  } else if (pixelRatio >= 2 && pixelRatio < 3) {
    images = require.context(
      "../assets/images/hdpi200",
      false,
      /\.jpg$|\.png$|.gif$/
    );
  } else if (pixelRatio >= 3) {
    images = require.context(
      "../assets/images/hdpi300",
      false,
      /\.jpg$|\.png$|.gif$/
    );
  }

  return images;
}

export function phoneNumber(value) {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }
  return /^[+]?[0-9]{1,}/.test(value);
}

export function changeFavicon(link) {
  const favicon = document.getElementById("favicon");
  if (favicon !== null) {
    favicon.href = "/" + link;
  }
}

export function saveFile(fileData, fileName) {
  FileSaver.saveAs(fileData, fileName);
}

export function pad(num, size = 2) {
  var s = "000000000" + num;
  return s.substr(s.length - size);
}
